export const breakpoints = {
    tabletSM: '670px',
    tablet: '740px',
    desktop: '900px',
    desktopHD: '1615px',

    mobile: '320px',
    ipads: '481px',
    screenS: '769px',
    screenL: '1025px',
    screenXL: '1201px',

    viewPortrait: 'portrait',
    viewLandscape: 'landscape'
}
 
export const resolutions = { 
    tabletSM: `(min-width: ${breakpoints.tabletSM})`,
    tablet: `(min-width: ${breakpoints.tablet})`,
    desktop: `(min-width: ${breakpoints.desktop})`,
    desktopHD: `(min-width: ${breakpoints.desktopHD})`,

    mobile: `(min-width: ${breakpoints.mobile})`,
    ipads: `(min-width: ${breakpoints.ipads})`,
    screenS: `(min-width: ${breakpoints.screenS})`,
    screenL: `(min-width: ${breakpoints.screenL})`,
    screenXL: `(min-width: ${breakpoints.screenXL})`,

    portrait: `(orientation: ${breakpoints.viewPortrait})`,
    landscape: `(orientation: ${breakpoints.viewLandscape})`
}

export const screenDim = {
    height: screen.availHeight,
    width: screen.availWidth
}

export const viewport = () => {
    if(window.innerHeight > window.innerWidth){
        return breakpoints.viewLandscape;
    } else {
        return breakpoints.viewPortrait;
    }
}
